module.exports = __webpack_public_path__ + "static/media/bright.39528e05.svg";